import React from 'react';
import { Container } from 'reactstrap';
import { ContactSectionProps } from '../../../constants/interface/interface';

const ContactSection = ({
  title,
  description,
  bgImage,
  buttonLabel,
  buttonLink,
}: ContactSectionProps) => {
  return (
    <Container>
      <div
        className="contact-section"
        style={{ '--bg-image': `url(${bgImage})` } as React.CSSProperties}
        data-aos="fade-up"
      >
        <div className="contact-content">
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <div>
          <a href={buttonLink} className="contact-button">
            {buttonLabel}
          </a>
        </div>
      </div>
    </Container>
  );
};

export default ContactSection;
